import axios, { AxiosResponse } from "axios";
import apiClient from "../../../../shared/infrastructure/api/client";
import { AvatarConfig, TherapistFigure } from "../../domain/types";

export interface TherapistFigureCreate {
    name: string;
    avatar: AvatarConfig;
    thumbnail?: string | null;
    height?: number;
}

export interface TherapistFigureUpdate {
    name?: string;
    avatar?: AvatarConfig;
    thumbnail?: string | null;
    height?: number;
}

// Public (patient) client: NO Firebase auth interceptor — the patient is
// unauthenticated and authorized solely by the board's URL token.
const publicClient = axios.create({
    baseURL: "/api",
    headers: { "Content-Type": "application/json" },
});

export const TherapistFiguresAPI = {
    // --- Therapist (authenticated) ---------------------------------------
    list: (): Promise<AxiosResponse<TherapistFigure[]>> =>
        apiClient.get("/therapist-figures"),

    create: (data: TherapistFigureCreate): Promise<AxiosResponse<TherapistFigure>> =>
        apiClient.post("/therapist-figures", data),

    update: (
        id: string,
        data: TherapistFigureUpdate,
    ): Promise<AxiosResponse<TherapistFigure>> =>
        apiClient.patch(`/therapist-figures/${id}`, data),

    delete: (id: string): Promise<AxiosResponse<void>> =>
        apiClient.delete(`/therapist-figures/${id}`),

    // --- Patient (public, token-scoped) ----------------------------------
    listByToken: (token: string): Promise<AxiosResponse<TherapistFigure[]>> =>
        publicClient.get(`/public/constellation/${token}/figures`),
};
